export default {
  'Please select an output format': 'Si prega di selezionare un formato di uscita',
}